import React from 'react';
import { motion } from 'framer-motion';
import reading_thetor from '../../../assets/images/educational_service/reading_thetor.jpg';
import GradientButton from '../../../components/atoms/GradientButton';
import { useMediaQuery } from 'react-responsive';

function ReadingThetor() {
  const isMobile = useMediaQuery({ query: '(max-width: 767px)' });
  return (
    <div className="w-full flex flex-col justify-between gap-4 sm:gap-10 max-w-[1200px] mx-auto px-4 md:px-10 py-10 md:py-20 relative z-10">
      <div className="flex flex-col md:flex-row justify-between w-full gap-4 sm:gap-10 xl:gap-16">
        <div className="flex-1 flex justify-center lg:justify-end relative">
          <motion.div
            initial={{ opacity: 0, x: isMobile ? 0 : -300 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.9, ease: 'easeOut' }}
            viewport={{ once: true, amount: 0.5 }}
          >
            <img
              src={reading_thetor}
              alt="Speech therapy session for child in Wasilla, Alaska clinic"
            />
          </motion.div>
        </div>
        <div
          className={`paragraphStyles flex-1 flex-col gap-3 text-left text-primary text-[18px] sm:text-[20px] md:text-[24px] font-bold`}
        >
          <p>• Educational Services</p>
          <ul className="text-[15px] lg:text-[17px] font-[500]  text-secondary pl-4 space-y-1">
            <li>Reading Support</li>
            <li>Math Support</li>
            <li>Dyslexia Support and Testing</li>
            <li>
              Additional Educational Support including Gifted Education Programs
            </li>
          </ul>
          <p>• Pediatric Feeding Therapy</p>
          <p>• Pediatric Occupational Therapy</p>
          <p>• Pediatric Speech Therapy</p>
          <p>• Pediatric Physical Therapy</p>
          <p>• Pediatric Telehealth Therapy Made Easy</p>
          <p>• Pediatric Tutoring and Education Services</p>
          <ul className="text-[15px] lg:text-[17px] font-[500]  text-secondary pl-4 mb-4">
            <li>Dyslexia Testing Package</li>
          </ul>
          <p>• Experienced 504 Advocates for School Services</p>
          <div className="mt-4">
            <GradientButton
              text="Schedule an Evaluation"
              width="w-full md:w-[240px]"
              navigateTo={'/contact'}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default ReadingThetor;
